export default {
  en: {
    keyword: 'Keyword',
    promotion: 'Promotion',
    code: 'Code',
    detail: 'Detail',
    periodOfStay: 'Period of Stay',
    night: 'Night',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedPromotionMessage: 'This promotion has been updated',
    deletedPromotionMessage: 'This promotion has been deleted'
  },
  th: {
    keyword: 'คำที่ต้องการค้นหา',
    promotion: 'โปรโมชั่น',
    code: 'โค้ด',
    detail: 'รายละเอียด',
    periodOfStay: 'ช่วงเวลาโปรโมชั่น',
    night: 'Night',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedPromotionMessage: 'โปรโมชั่นนี้มีการแก้ไข',
    deletedPromotionMessage: 'โปรโมชั่นนี้ถูกลบไปแล้ว'
  }
}
